"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandIcon = function ExpandIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (className || '') + '',
    focusable: false,
    height: "10",
    role: "presentation",
    viewBox: "0 0 16 10",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.1484 0.648437L15.8516 1.35156L8 9.20312L0.148438 1.35156L0.851563 0.648438L8 7.79687L15.1484 0.648437Z"
  }));
};

ExpandIcon.defaultProps = {
  className: undefined
};
ExpandIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = ExpandIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFeHBhbmRJY29uIiwiY2xhc3NOYW1lIiwiZGVmYXVsdFByb3BzIiwidW5kZWZpbmVkIiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwic3RyaW5nIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvVG9hc3QvRXhwYW5kSWNvbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgRXhwYW5kSWNvbiA9ICh7IGNsYXNzTmFtZSB9KSA9PiAoXG4gIDxzdmdcbiAgICBjbGFzc05hbWU9eyhjbGFzc05hbWUgfHwgJycpICsgJyd9XG4gICAgZm9jdXNhYmxlPXtmYWxzZX1cbiAgICBoZWlnaHQ9XCIxMFwiXG4gICAgcm9sZT1cInByZXNlbnRhdGlvblwiXG4gICAgdmlld0JveD1cIjAgMCAxNiAxMFwiXG4gICAgd2lkdGg9XCIxNlwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gID5cbiAgICA8cGF0aCBkPVwiTTE1LjE0ODQgMC42NDg0MzdMMTUuODUxNiAxLjM1MTU2TDggOS4yMDMxMkwwLjE0ODQzOCAxLjM1MTU2TDAuODUxNTYzIDAuNjQ4NDM4TDggNy43OTY4N0wxNS4xNDg0IDAuNjQ4NDM3WlwiIC8+XG4gIDwvc3ZnPlxuKTtcblxuRXhwYW5kSWNvbi5kZWZhdWx0UHJvcHMgPSB7XG4gIGNsYXNzTmFtZTogdW5kZWZpbmVkXG59O1xuXG5FeHBhbmRJY29uLnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBFeHBhbmRJY29uO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFQSxJQUFNQSxVQUFVLEdBQUcsU0FBYkEsVUFBYTtFQUFBLElBQUdDLFNBQUgsUUFBR0EsU0FBSDtFQUFBLG9CQUNqQjtJQUNFLFNBQVMsRUFBRSxDQUFDQSxTQUFTLElBQUksRUFBZCxJQUFvQixFQURqQztJQUVFLFNBQVMsRUFBRSxLQUZiO0lBR0UsTUFBTSxFQUFDLElBSFQ7SUFJRSxJQUFJLEVBQUMsY0FKUDtJQUtFLE9BQU8sRUFBQyxXQUxWO0lBTUUsS0FBSyxFQUFDLElBTlI7SUFPRSxLQUFLLEVBQUM7RUFQUixnQkFTRTtJQUFNLENBQUMsRUFBQztFQUFSLEVBVEYsQ0FEaUI7QUFBQSxDQUFuQjs7QUFjQUQsVUFBVSxDQUFDRSxZQUFYLEdBQTBCO0VBQ3hCRCxTQUFTLEVBQUVFO0FBRGEsQ0FBMUI7QUFJQUgsVUFBVSxDQUFDSSxTQUFYLEdBQXVCO0VBQ3JCSCxTQUFTLEVBQUVJLGtCQUFBLENBQVVDO0FBREEsQ0FBdkI7ZUFJZU4sVSJ9